// extracted by mini-css-extract-plugin
module.exports = {"loader-dark":"loader_loader-dark__2j5f9","loader-light":"loader_loader-light__1G07I","zoom":"loader_zoom__3ap47"};